(() => {
  const labels = ['Type', 'Grouping', 'Diameter', 'Taper'];

  function choicesFor(catalog, selection, index) {
    const ready = selection.slice(0, index).length === index && selection.slice(0, index).every(Boolean);
    if (!ready) return [];
    const matches = catalog.filter(item => selection.slice(0, index).every((value, i) => item.values[i] === value));
    const values = [...new Set(matches.map(item => item.values[index]))];
    if (index === 0) values.sort((a, b) => ['Round Liner', 'Round Shader', 'Magnum', 'Soft Edge Magnum'].indexOf(a) - ['Round Liner', 'Round Shader', 'Magnum', 'Soft Edge Magnum'].indexOf(b));
    if (index === 1 || index === 2) values.sort((a, b) => parseFloat(a.replace('#', '')) - parseFloat(b.replace('#', '')));
    if (index === 3) values.sort((a, b) => a.localeCompare(b));
    return values;
  }

  function resolve(catalog, selection) {
    return selection.length === 4 && selection.every(Boolean)
      ? catalog.find(item => item.values.every((value, i) => selection[i] === value)) || null
      : null;
  }

  function productUrl(root, handle, origin) {
    return new URL(`${root.replace(/\/$/, '')}/products/${handle}`, origin);
  }

  class RoyalGoldigoSelector extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.catalog = JSON.parse(this.querySelector('[data-goldigo-catalog]').textContent);
      this.product = JSON.parse(this.querySelector('[data-goldigo-product]').textContent);
      this.section = this.closest('.goldigo-pdp');
      this.description = this.section.querySelector('[data-goldigo-description]');
      this.product.description = this.description.innerHTML;
      this.heading = this.section.querySelector('h1');
      this.previewMode = this.dataset.designMode === 'true' || window.location.hostname.endsWith('.shopifypreview.com');
      const preview = this.querySelector('[data-goldigo-preview-products]');
      this.previewProducts = this.previewMode && preview ? JSON.parse(preview.textContent) : [];
      this.requestSerial = 0;
      this.options = this.querySelector('[data-goldigo-options]');
      this.input = this.querySelector('[data-goldigo-variant]');
      this.add = this.querySelector('[data-goldigo-add]');
      this.price = this.querySelector('[data-goldigo-price]');
      this.sku = this.querySelector('[data-goldigo-sku]');
      this.status = this.querySelector('[data-goldigo-status]');
      this.summary = this.querySelector('[data-goldigo-summary]');
      this.retry = this.querySelector('[data-goldigo-retry]');
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' });
      this.restore();
      this.options.addEventListener('click', event => {
        const button = event.target.closest('button[data-index]');
        if (!button || button.disabled || button.getAttribute('aria-pressed') === 'true') return;
        const index = Number(button.dataset.index);
        this.selection = this.selection.slice(0, index);
        this.selection[index] = button.dataset.value;
        this.requestSerial++;
        this.render(index);
        this.loadSelectedProduct();
      });
      this.querySelector('form').addEventListener('submit', event => {
        if (this.previewMode || !this.selectedVariant?.available || this.selectedVariant.price <= 0 || this.loading || !this.selectedConfig || String(this.selectedVariant.id) !== this.selectedConfig.id || this.selectedVariant.sku !== this.selectedConfig.sku) event.preventDefault();
      });
      this.retry.addEventListener('click', () => { this.requestSerial++; this.render(); this.loadSelectedProduct(); });
      this.onPopState = () => { this.restore(); this.render(); this.loadSelectedProduct(); };
      window.addEventListener('popstate', this.onPopState);
      this.gallery = this.closest('.goldigo-layout').querySelector('.goldigo-gallery');
      this.onImageClick = event => {
        const link = event.target.closest('[data-goldigo-image]');
        if (!link) return;
        event.preventDefault();
        const image = this.gallery.querySelector('.goldigo-main-image');
        image.src = link.href;
        image.removeAttribute('srcset');
        image.alt = link.querySelector('img').alt;
      };
      this.gallery.addEventListener('click', this.onImageClick);
      this.render();
      this.loadSelectedProduct();
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.onPopState);
      this.gallery?.removeEventListener('click', this.onImageClick);
      this.requestSerial++;
    }

    restore() {
      const requested = new URL(window.location.href).searchParams.get('variant') || this.dataset.initialVariant;
      const config = this.catalog.find(item => item.id === String(requested));
      this.selection = config ? [...config.values] : [];
      this.requestSerial++;
    }

    render(focusIndex) {
      this.options.replaceChildren();
      labels.forEach((label, index) => {
        const fieldset = document.createElement('fieldset');
        const legend = document.createElement('legend');
        legend.textContent = label;
        fieldset.append(legend);
        const choices = document.createElement('div');
        choices.className = 'goldigo-choice-list';
        const values = choicesFor(this.catalog, this.selection, index);
        values.forEach(value => {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = value;
          button.dataset.index = index;
          button.dataset.value = value;
          button.setAttribute('aria-pressed', String(this.selection[index] === value));
          choices.append(button);
        });
        if (!values.length) {
          const hint = document.createElement('p');
          hint.className = 'goldigo-placeholder';
          hint.textContent = `Choose ${labels[index - 1]?.toLowerCase() || 'type'} first`;
          choices.append(hint);
        }
        fieldset.append(choices);
        this.options.append(fieldset);
      });
      this.selectedConfig = resolve(this.catalog, this.selection);
      this.selectedVariant = this.selectedConfig?.handle === this.product.handle
        ? this.product.variants.find(item => String(item.id) === this.selectedConfig.id && item.sku === this.selectedConfig.sku)
        : null;
      const variant = this.selectedVariant;
      this.loading = false;
      this.retry.hidden = true;
      this.input.disabled = !variant || this.previewMode;
      this.input.value = variant?.id || '';
      this.add.disabled = this.previewMode || !variant?.available || variant.price <= 0;
      this.add.textContent = this.previewMode && variant ? 'Draft preview' : !variant ? 'Choose a configuration' : !variant.available ? 'Sold out' : variant.price <= 0 ? 'Unavailable' : 'Add to cart';
      this.price.textContent = variant ? this.money.format(variant.price / 100) : 'Choose your configuration';
      this.sku.textContent = variant ? `SKU: ${variant.sku}` : 'SKU: Select all four options';
      this.summary.textContent = this.selection.filter(Boolean).join(' · ');
      this.status.textContent = variant ? this.previewMode ? 'Draft preview · Box of 20 · Purchasing is disabled' : `${variant.available ? 'In stock' : 'Sold out'} · Box of 20` : 'Select all four options to see price and availability.';
      if (focusIndex !== undefined) {
        [...this.options.querySelectorAll('button')].find(button => Number(button.dataset.index) === focusIndex && button.dataset.value === this.selection[focusIndex])?.focus({ preventScroll: true });
        if (variant) {
          this.updateUrl(this.selectedConfig);
          this.updateSchema(this.product, variant);
        }
      }
    }

    async loadSelectedProduct() {
      const config = this.selectedConfig;
      if (!config || config.handle === this.product.handle) return;
      const serial = this.requestSerial;
      this.loading = true;
      this.input.disabled = true;
      this.add.disabled = true;
      this.add.textContent = 'Loading configuration…';
      this.price.textContent = 'Loading price…';
      this.sku.textContent = `SKU: ${config.sku}`;
      this.status.textContent = 'Loading your selected configuration…';
      try {
        let product;
        if (this.previewMode) product = this.previewProducts.find(item => item.handle === config.handle);
        if (!product) {
          const url = productUrl(this.dataset.rootUrl, config.handle, window.location.origin);
          url.pathname += '.js';
          const response = await fetch(url.href, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Product unavailable');
          product = await response.json();
        }
        if (serial !== this.requestSerial || !this.isConnected) return;
        const variant = product.variants?.find(item => String(item.id) === config.id && item.sku === config.sku);
        if (product.handle !== config.handle || !variant || !Number.isFinite(variant.price) || variant.price < 0) throw new Error('Configuration unavailable');
        this.product = product;
        const productId = this.querySelector('[name="product-id"]');
        if (productId) productId.value = product.id;
        this.heading.textContent = product.title;
        const breadcrumb = document.querySelector('.breadcrumbs .breadcrumb-product-link');
        if (breadcrumb) breadcrumb.textContent = product.title;
        const image = this.gallery.querySelector('.goldigo-main-image');
        if (image) image.alt = product.title;
        this.description.innerHTML = product.description || '';
        this.render();
        this.updateUrl(config);
        this.updateSchema(product, variant);
      } catch (error) {
        if (serial !== this.requestSerial || !this.isConnected) return;
        this.loading = false;
        this.selectedVariant = null;
        this.input.disabled = true;
        this.input.value = '';
        this.add.disabled = true;
        this.add.textContent = 'Configuration unavailable';
        this.price.textContent = 'Price unavailable';
        this.status.textContent = 'We could not load this configuration. Please try again.';
        this.retry.hidden = false;
      }
    }

    updateUrl(config) {
      const url = this.previewMode ? new URL(window.location.href) : productUrl(this.dataset.rootUrl, config.handle, window.location.origin);
      url.searchParams.set('variant', config.id);
      window.history.replaceState({}, '', url);
      if (!this.previewMode) {
        const canonical = document.querySelector('link[rel="canonical"]');
        if (canonical) canonical.href = productUrl(this.dataset.rootUrl, config.handle, window.location.origin).href;
      }
      document.title = `${this.product.title} | Royal Ink`;
    }

    updateSchema(product, variant) {
      const schema = this.section.querySelector('[data-goldigo-schema]');
      if (!schema || this.previewMode) return;
      const image = this.gallery.querySelector('.goldigo-main-image');
      const url = productUrl(this.dataset.rootUrl, product.handle, window.location.origin);
      url.searchParams.set('variant', variant.id);
      schema.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'Product', name: product.title, sku: variant.sku, brand: { '@type': 'Brand', name: 'GOLDIGO' }, image: image ? [image.src] : [], offers: { '@type': 'Offer', url: url.href, priceCurrency: this.dataset.currency || 'USD', price: (variant.price / 100).toFixed(2), availability: variant.available ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock' } });
    }
  }
  if (!customElements.get('royal-goldigo-selector')) customElements.define('royal-goldigo-selector', RoyalGoldigoSelector);
})();
